export default __webpack_public_path__ + "static/platinum-banner-bf53ec92ead4ceb8cb0edd1212b00a36.svg";